import { Component, h, Prop, Element, Watch } from '@stencil/core';

@Component({
  tag: 'jackery-button',
  styleUrl: 'jackery-button.css',
  shadow: true,
})
export class JackeryButton {
  @Element() element: HTMLElement;
  /**
   * 按钮类型
   */
  @Prop() type?: "primary" | "success" | "danger" | "warning"
  /**
   * 按钮尺寸
   */
  @Prop() size?: "small" | "normal" | "big" | "large";
  /**
   * 按钮图标
   */
  @Prop() icon?: string;
  /**
   * 按钮形状
   */
  @Prop() shape?: "round" | "square";
  /**
   * 朴素按钮
   */
  @Prop() plain?: string;
  /**
   * 加载状态
   */
  @Prop() loading?: string;
  /**
   * 加载类型
   */
  @Prop() loadtype?: "circular" | "spinner";
  /**
   * 加载颜色
   */
  @Prop() loadingcolor?: string;
  /**
   * 加载尺寸
   */
  @Prop() loadingsize?: string;
  /**
   * 是否禁用
   */
  @Prop() disabled?: string;
  /**
   * 浅色按钮？
   */
  @Prop() light?: string;

  @Watch('loading')
  loadingChanged() {
    this.handleUpdatePro("loading")
  }

  @Watch('disabled')
  disabledChanged() {
    this.handleUpdatePro("disabled")
  }

  @Watch('type')
  typeChanged() {
    this.handleUpdatePro("type")
  }

  renderIcon = () => {
    if (this.icon && this.icon.startsWith("http")) {
      return <img class="jackery-button-icon" src={this.icon}></img>;
    }
    if (this.loading !== undefined) {
      return (
        <jackery-loading
          class="jackery-button-load"
          color={this.loadingcolor ? this.loadingcolor : "#fff"}
          size={this.loadingsize ? this.loadingsize : '20'}
          type={this.loadtype ? this.loadtype : "spinner"}
        />
      );
    }
    return null;
  };

  componentDidLoad() {
    this.handleProperty()

    this.element.addEventListener("click", (e: Event) => {
      if (this.disabled || this.loading !== undefined) {
        e.stopPropagation();
      }
    });
    this.element.addEventListener("touchstart", () => {});
  }

  handleProperty() { // FIX：组件嵌套使用属性无法生效问题(未知原因)
    if(this.type) {this.element.setAttribute("type", this.type)}
    if(this.size) {this.element.setAttribute("size", this.size)}
    if(this.icon) {this.element.setAttribute("icon", this.icon)}
    if(this.shape) {this.element.setAttribute("shape", this.shape)}
    if(this.plain !== undefined) {this.element.setAttribute("plain", this.plain)}
    if(this.disabled !== undefined) {this.element.setAttribute("disabled", this.disabled)}
    if(this.light !== undefined) {this.element.setAttribute("light", this.light)}
    if(this.loading !== undefined) {this.element.setAttribute("loading", this.loading)}
    if(this.loading !== undefined && this.loadtype) {this.element.setAttribute("loadtype", this.loadtype)}
    if(this.loading !== undefined && this.loadingcolor) {this.element.setAttribute("loadingcolor", this.loadingcolor)}
    if(this.loading !== undefined && this.loadingsize) {this.element.setAttribute("loadingsize", this.loadingsize)}
  }

  handleUpdatePro(key: "type" | "size" | "icon" | "shape" | "plain" | "disabled" | "light" | "loading" | "loadtype" | "loadingcolor" | "loadingsize") {
    if(this[key]) {
      this.element.setAttribute(key, this[key])
    }
  }

  render() {
    return (
      <div
        class={{
          "jackery-button": true
        }}
      >
        {this.renderIcon()}
        <slot></slot>
      </div>
    );
  }
}
